<app-page
  headline="Currency Conversion"
  breadcrumb="Downloads"
  breadcrumbLink="/download"
  [headlinePaddingLeft]="undefined"
>
  <div stack-layout gap="sm">
    <Text color="on-background-variant" display="block">
      Download the latest currency conversion rates based on the selected source currency.
    </Text>

    <div
      box-layout
      color="primary-surface"
      border="light"
      borderRadius="xs"
      elevation="raised"
      padding="lg"
    >
      <div stack-layout gap="md" [fullWidth]="true">
        <div stack-layout gap="xs" [fullWidth]="true">
          <Text role="headline-small"
            >Source Currency <span style="color: #d32f2f">*</span></Text
          >
          <app-select
            [form]="downloadForm"
            controlName="sourceCurrency"
            [options]="sourceCurrencyOptions()"
            placeholder="select a source currency"
            [blackText]="true"
            style="display: block; width: 300px"
          />
        </div>

        <div>
          <app-download-button
            mode="text"
            label="Download (xlsx)"
            [blobObservable]="
              ecommerceService.downloadCurrencyConversion(selectedSourceCurrency() || '')
            "
            [downloadFileName]="currencyConversionFileName()"
            [disable]="downloadForm.invalid"
          />
        </div>
      </div>
    </div>
  </div>
</app-page>
